import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TransactionOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";

export abstract class APromotion extends ABusiness {
    readonly icon = () => h(TransactionOutlined, {style: 'color: #ef4444'});
    readonly title = '促销';
    readonly description = '';
    readonly implementations = [{value: 'tier_group', label: '阶梯团'}];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }
}